import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import _isEqual from 'lodash/isEqual';

import { Checkbox } from '../../../utilites';
import LoaderDetails from './LoaderDetails/LoaderDetails';

import './registerDetails.scss';
import {useSelector} from "react-redux";

const RegisterDetails = memo(({ tn, transferId, isTabLoading, handleContractCheck }) => {
  const check = tn && !_isEqual(tn, {});
  const {accessFeatures} = useSelector(({user}) => user);
  const isExtensionThreeImplementaition = accessFeatures["extension.implementation.type.three"]
  const handleLocalContractCheck = (e) => {
    handleContractCheck(e, transferId);
  };

  return isTabLoading ? (
    <LoaderDetails />
  ) : (
    <div className="overdue-content-section">
      <table className="table hover">
        <thead>
          <tr className="registerDetails-table-header">
            <th scope="col"></th>
            <th scope="col">
              <p>Номер</p>
            </th>
            <th scope="col">
              <p>Клиент</p>
            </th>
            <th scope="col">
              <div className="registerDetails-table-body-box">
                <div className="registerDetails-table-body-box-name">
                  <p>Наименование</p>
                </div>
                <div className="registerDetails-table-body-box-purity">
                  <p>Проба</p>
                </div>
                <div className="registerDetails-table-body-box-weight">
                  <p>
                    Вес общий <br />
                    (лигатурный), г.
                  </p>
                </div>
              </div>
            </th>
            <th scope="col">
              <p>
                Дней <br />
                просрочки
              </p>
            </th>
            {!isExtensionThreeImplementaition && <th scope="col">
              <p>
                Дней льготного <br /> срока
              </p>
            </th>}
            <th scope="col">
              <p>
                Сумма на выкуп <br /> до перевода, руб.
              </p>
            </th>
            <th scope="col">
              <p>
                Размер <br />
                микрозайма, руб.
              </p>
            </th>
            <th scope="col">
              <p>
                Оценочная <br />
                стоимость, руб.
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          {check &&
            tn.deal &&
            tn.deal.length !== 0 &&
            tn.deal.map((i, ind) => {

              let delayDays = '';
              if (accessFeatures['deal.expired.total_to_pay_remind']) {
                const days = isExtensionThreeImplementaition ? i.delayDays : i.graceDays;
                if (i.totalToPay >= i.totalEstimatedValue && days > 30) {
                  delayDays = 'overdue-delayColorGreen';
                } else {
                  delayDays = 'overdue-delayColorRed';
                }
              }

              return(
                      <tr key={i.id}>
                        <td className="table-cellcontent">
                          <Checkbox
                              id={i.id}
                              name={i.id}
                              onChange={handleLocalContractCheck}
                              value={i.checked}
                          />
                          <p>{ind + 1}</p>
                        </td>
                        <td>
                          <p>
                            <Link className="table-link" to={`client/${i.clientId}/contracts/${i.id}`}>
                              <span>{i.dealNumber || i.id}</span>
                            </Link>
                          </p>
                        </td>
                        <td>
                          <p>{i.clientFullName}</p>
                        </td>
                        <td>
                          <div className="registerDetails-table-body-group">
                            {i.positions &&
                                i.positions.length !== 0 &&
                                i.positions.map((item, ind) => (
                                    <div
                                        className="registerDetails-table-body-box"
                                        key={item.names.join() + ind}>
                                      <div className="registerDetails-table-body-box-name">
                                        <p>{item.names.join(' ')}</p>
                                      </div>
                                      <div className="registerDetails-table-body-box-purity">
                                        <p>
                                          {item.purityType} {item.purityName}
                                        </p>
                                      </div>
                                      <div className="registerDetails-table-body-box-weight">
                                        <p>
                                          {(+item.grossWeight).toFixed(2)} ({(+item.pureWeight).toFixed(2)})
                                        </p>
                                      </div>
                                    </div>
                                ))}
                          </div>
                        </td>
                        <td>
                          <p className={delayDays}>{i.delayDays}</p>
                        </td>
                        {!isExtensionThreeImplementaition && <td>
                          <p className={delayDays}>{i.graceDays}</p>
                        </td>}
                        <td>
                          <p>{i.totalToPay.toFixed(2)}</p>
                        </td>
                        <td>
                          <p>{i.amount.toFixed(2)}</p>
                        </td>
                        <td>
                          <p>{i.totalEstimatedValue.toFixed(2)}</p>
                        </td>
                      </tr>
                  )
          })}
        </tbody>
        <tfoot>
          <tr className="registerDetails-table-footer">
            <td></td>
            <td colSpan="4">
              <p>Итого</p>
            </td>
            <td colSpan="2">
              <p>Размер микрозайма:</p>
              <p>Оценочная стоимость:</p>
            </td>
            <td>
              <p>
                {check && tn.totalTransferAmount && tn.totalTransferAmount.toFixed(2)}{' '}
                руб.
              </p>
              <p>
                {check &&
                  tn.totalTransferEstimatedValue &&
                  tn.totalTransferEstimatedValue.toFixed(2)}{' '}
                руб.
              </p>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

export default RegisterDetails;
